import { render, staticRenderFns } from "./InlineEditableDelegateTable.vue?vue&type=template&id=5833016e&scoped=true"
import script from "./InlineEditableDelegateTable.vue?vue&type=script&lang=js"
export * from "./InlineEditableDelegateTable.vue?vue&type=script&lang=js"
import style0 from "./InlineEditableDelegateTable.vue?vue&type=style&index=0&id=5833016e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5833016e",
  null
  
)

export default component.exports